import React, { useReducer, useContext, useCallback, useState, useEffect } from "react"
import MainReducer from 'main/state/MainReducer'
import { Commands } from 'shared/resources/BitbiteCommands';
import { SessionContext } from 'shared/system-controls/session/SessionProvider';

export const MainContext = React.createContext();

const MainState = ({ children }) => {
	const initialState = {
		areas: [],
	}
	const [state, dispatch] = useReducer(MainReducer, initialState);
	const { asyncServiceCall } = useContext(SessionContext);
	const [windowDimensions, setWindowDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });

	const getConstants = useCallback(async (list) => {
		try {
			list = list || {};
			let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_CONSTANTS_GET, { ...list });
			dispatch({ type: 'SET_STATE_DATA', payload: res });
		}
		catch (err) {
			dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
		}
	}, [asyncServiceCall])

	//----------------------------------------
	const getAutoJobsState = useCallback(async () => {
		try {
			let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_AUTO_JOBS_STATUS_GET, {});
			dispatch({ type: 'SET_STATE_DATA', payload: res });
		}
		catch (err) {
			dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
		}
	}, [asyncServiceCall])

	//----------------------------------------
	const resetAutoJobsState = useCallback(async () => {
		try {
			await asyncServiceCall(Commands.API_URL_BITBITE_BO_AUTO_JOBS_STATUS_RESET, {});
		}
		catch (err) {
			dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
		}
	}, [asyncServiceCall])

	//-----------------------------------------------------------------
	useEffect(() => {
		const handleResize = () => setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);


	return (
		<MainContext.Provider
			value={{
				...state,
				isMobile: windowDimensions?.width < 768,
				isTablet: windowDimensions?.width >= 768 && windowDimensions?.width < 1024,
				isWideTablet: windowDimensions?.width >= 980 && windowDimensions?.width < 1024,
				isMobileTablet: windowDimensions?.width < 1024,
				dispatch,
				getConstants,
				getAutoJobsState,
				resetAutoJobsState,
			}}
		>
			{children}
		</MainContext.Provider>
	)
}

export default MainState
